import { render } from "./Separator.vue?vue&type=template&id=197fe1e6&scoped=true&ts=true"
import script from "./Separator.vue?vue&type=script&lang=ts"
export * from "./Separator.vue?vue&type=script&lang=ts"

import "./Separator.vue?vue&type=style&index=0&id=197fe1e6&lang=stylus&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197fe1e6"]])

export default __exports__